export const GET_ALL_DATA_REQUEST = 'GET_ALL_DATA_REQUEST';
export const GET_ALL_DATA_SUCCESS = 'GET_ALL_DATA_SUCCESS';
export const GET_ALL_DATA_FAIL = 'GET_ALL_DATA_FAIL';

export const GET_ALL_USERS_REQUEST = 'GET_ALL_USERS_REQUEST';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAIL = 'GET_ALL_USERS_FAIL';

export const GET_ALL_USER_FORUM_STATS_REQUEST = 'GET_ALL_USER_FORUM_STATS_REQUEST';
export const GET_ALL_USERS_FORUM_STATS_SUCCESS = 'GET_ALL_USERS_FORUM_STATS_SUCCESS';
export const GET_ALL_USERS_FORUM_STATS_FAIL = 'GET_ALL_USERS_FORUM_STATS_FAIL';

export const GET_BOT_REQUEST = 'GET_BOT_REQUEST';
export const GET_BOT_SUCCESS = 'GET_BOT_SUCCESS';
export const GET_BOT_FAIL = 'GET_BOT_FAIL';

export const GET_ALL_BOT_FORUM_STATS_REQUEST = 'GET_ALL_BOT_FORUM_STATS_REQUEST';
export const GET_ALL_BOT_FORUM_STATS_SUCCESS = 'GET_ALL_BOT_FORUM_STATS_SUCCESS';
export const GET_ALL_BOT_FORUM_STATS_FAIL = 'GET_ALL_BOT_FORUM_STATS_FAIL';

export const GET_FILENAMES_REQUEST = 'GET_FILENAMES_REQUEST';
export const GET_FILENAMES_SUCCESS = 'GET_FILENAMES_SUCCESS';
export const GET_FILENAMES_FAIL = 'GET_FILENAMES_FAIL';

export const GET_FILENAMES_IUIU_REQUEST = 'GET_FILENAMES_IUIU_REQUEST';
export const GET_FILENAMES_IUIU_SUCCESS = 'GET_FILENAMES_IUIU_SUCCESS';
export const GET_FILENAMES_IUIU_FAIL = 'GET_FILENAMES_IUIU_FAIL';

export const GET_CERTIFICATES_LIST_REQUEST = 'GET_CERTIFICATES_REQUEST';
export const GET_CERTIFICATES_LIST_SUCCESS = 'GET_CERTIFICATES_SUCCESS';
export const GET_CERTIFICATES_LIST_FAIL = 'GET_CERTIFICATES_FAIL';

export const GET_BLINDBOX_LIST_REQUEST = 'GET_BLINDBOX_LIST_REQUEST';
export const GET_BLINDBOX_LIST_SUCCESS = 'GET_BLINDBOX_LIST_SUCCESS';
export const GET_BLINDBOX_LIST_FAIL = 'GET_BLINDBOX_LIST_FAIL';

export const GET_MCQ_LIST_REQUEST = 'GET_MCQ_LIST_REQUEST';
export const GET_MCQ_LIST_SUCCESS = 'GET_MCQ_LIST_SUCCESS';
export const GET_MCQ_LIST_FAIL = 'GET_MCQ_LIST_FAIL'